<template>
  <v-container>
    <v-card elevation="2">
      <v-card-title>
        Latest Medical Assessment
      </v-card-title>
      <template v-if="!loading && medicalAssessment">
        <v-simple-table>
          <tbody>
            <tr>
              <td><strong>Assessment Date</strong></td>
              <td>
                {{ medicalAssessment.assessmentDate | moment("Do MMM YYYY, h:mm a") }}
              </td>
              <td></td>
            </tr>
            <tr>
              <td><strong>Age</strong></td>
              <td>{{ medicalAssessment.age }}</td>
              <td></td>
            </tr>
          </tbody>
        </v-simple-table>

        <v-tabs v-model="tab" background-color="secondary" color="secondary" center-active fixed-tabs show-arrows dark>
          <v-tabs-slider color="primary"></v-tabs-slider>

          <v-tab key="Lifestyle"><strong>Lifestyle</strong></v-tab>
          <v-tab key="Goals"><strong>Goals</strong></v-tab>
          <v-tab key="Medical Information">
            <strong>Medical Info</strong>
          </v-tab>
          <v-tab key="Exercise"><strong>Exercise</strong></v-tab>
          <v-tab key="Nutritional Information"><strong>Nutritional Info</strong></v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item key="Lifestyle">
            <v-simple-table>
              <tbody>
                <tr>
                  <td><strong>Level of Stress</strong></td>
                  <td>{{ medicalAssessment.levelOfStress }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="level_of_stress"
                      :notes="getCoachNotes('level_of_stress')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Handle Stress</strong></td>
                  <td>
                    {{ medicalAssessment.handleStress }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="handle_stress"
                      :notes="getCoachNotes('handle_stress')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Handle Stress</strong></td>
                  <td>
                    {{ medicalAssessment.handleStress }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="handle_stress"
                      :notes="getCoachNotes('handle_stress')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Hours of Sleep</strong></td>
                  <td>
                    {{ medicalAssessment.hoursOfSleep }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="hours_of_sleep"
                      :notes="getCoachNotes('hours_of_sleep')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Quality of Sleep</strong></td>
                  <td>
                    {{ medicalAssessment.qualityOfSleep }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="quality_of_sleep"
                      :notes="getCoachNotes('quality_of_sleep')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Support</strong></td>
                  <td>
                    {{ medicalAssessment.support }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="support"
                      :notes="getCoachNotes('support')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item key="Goals">
            <v-simple-table>
              <tbody>
                <tr>
                  <td><strong>Goal Definition</strong></td>
                  <td>{{ medicalAssessment.goalDefinition }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="goal_definition"
                      :notes="getCoachNotes('goal_definition')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Another Goal</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.anotherGoal) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="another_goal"
                      :notes="getCoachNotes('another_goal')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Another Goal Description</strong></td>
                  <td>{{ medicalAssessment.anotherGoalDescription }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="another_goal_description"
                      :notes="getCoachNotes('another_goal_description')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Goal Time Frame</strong></td>
                  <td>{{ medicalAssessment.goalTimeFrame }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="goal_time_frame"
                      :notes="getCoachNotes('goal_time_frame')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Goal Important</strong></td>
                  <td>{{ medicalAssessment.goalImportant }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="goal_important"
                      :notes="getCoachNotes('goal_important')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Lack of Motivation</strong></td>
                  <td>{{ medicalAssessment.lackOfMotivation }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="lack_of_motivation"
                      :notes="getCoachNotes('lack_of_motivation')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Lack of Energy</strong></td>
                  <td>{{ medicalAssessment.lackOfEnergy }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="lack_of_energy"
                      :notes="getCoachNotes('lack_of_energy')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Lack of Consistency</strong></td>
                  <td>{{ medicalAssessment.lackOfConsistency }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="lack_of_consistency"
                      :notes="getCoachNotes('lack_of_consistency')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Injury</strong></td>
                  <td>{{ medicalAssessment.injury }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="injury"
                      :notes="getCoachNotes('injury')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>What Type of Exercise</strong></td>
                  <td>{{ medicalAssessment.whatTypeOfExercise }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="what_type_of_exercise"
                      :notes="getCoachNotes('what_type_of_exercise')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Certain Exercises Properly</strong></td>
                  <td>{{ medicalAssessment.certainExercisesProperly }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="certain_exercises_properly"
                      :notes="getCoachNotes('certain_exercises_properly')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Enough Time to Exercise</strong></td>
                  <td>{{ medicalAssessment.enoughTimeToExercise }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="enough_time_to_exercise"
                      :notes="getCoachNotes('enough_time_to_exercise')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>What to Eat</strong></td>
                  <td>{{ medicalAssessment.whatToEat }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="what_to_eat"
                      :notes="getCoachNotes('what_to_eat')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>How Much to Eat</strong></td>
                  <td>{{ medicalAssessment.howMuchToEat }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="how_much_to_eat"
                      :notes="getCoachNotes('how_much_to_eat')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Planning Meals</strong></td>
                  <td>{{ medicalAssessment.planningMeals }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="planning_meals"
                      :notes="getCoachNotes('planning_meals')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Enough Time to Cook</strong></td>
                  <td>{{ medicalAssessment.enoughTimeToCook }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="enough_time_to_cook"
                      :notes="getCoachNotes('enough_time_to_cook')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>How to Cook</strong></td>
                  <td>{{ medicalAssessment.howToCook }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="how_to_cook"
                      :notes="getCoachNotes('how_to_cook')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Food Cravings</strong></td>
                  <td>{{ medicalAssessment.foodCravings }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="food_cravings"
                      :notes="getCoachNotes('food_cravings')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Eating Poorly</strong></td>
                  <td>{{ medicalAssessment.eatingPoorly }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="eating_poorly"
                      :notes="getCoachNotes('eating_poorly')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Always Hungry</strong></td>
                  <td>{{ medicalAssessment.alwaysHungry }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="always_hungry"
                      :notes="getCoachNotes('always_hungry')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Over Eating</strong></td>
                  <td>{{ medicalAssessment.overEating }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="over_eating"
                      :notes="getCoachNotes('over_eating')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Weekend Wobbles</strong></td>
                  <td>{{ medicalAssessment.weekendWobbles }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="weekend_wobbles"
                      :notes="getCoachNotes('weekend_wobbles')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Cultural Challenges</strong></td>
                  <td>{{ medicalAssessment.culturalChallenges }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="cultural_challenges"
                      :notes="getCoachNotes('cultural_challenges')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Regularly Cycling</strong></td>
                  <td>{{ medicalAssessment.regularlyCycling }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="regularly_cycling"
                      :notes="getCoachNotes('regularly_cycling')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Excessive Alcohol</strong></td>
                  <td>{{ medicalAssessment.excessiveAlcohol }}</td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="excessive_alcohol"
                      :notes="getCoachNotes('excessive_alcohol')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item key="Medical Information">
            <v-simple-table>
              <tbody>
                <tr>
                  <td><strong>Heart Condition</strong></td>
                  <td>
                    {{ medicalAssessment.heartCondition }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="heart_condition"
                      :notes="getCoachNotes('heart_condition')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>High Blood Pressure</strong></td>
                  <td>
                    {{ medicalAssessment.highBloodPressure }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="high_blood_pressure"
                      :notes="getCoachNotes('high_blood_pressure')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Diabetes</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.diabetes) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="diabetes"
                      :notes="getCoachNotes('diabetes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>High Cholesterol</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.highCholesterol) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="high_cholesterol"
                      :notes="getCoachNotes('high_cholesterol')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Chest Pain</strong></td>
                  <td>
                    {{ medicalAssessment.chestPain }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="chest_pain"
                      :notes="getCoachNotes('chest_pain')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Dizziness</strong></td>
                  <td>
                    {{ medicalAssessment.dizziness }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="dizziness"
                      :notes="getCoachNotes('dizziness')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Joint Pain</strong></td>
                  <td>
                    {{ medicalAssessment.jointPain }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="joint_pain"
                      :notes="getCoachNotes('joint_pain')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Back Neck Pain</strong></td>
                  <td>
                    {{ medicalAssessment.backNeckPain }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="back_neck_pain"
                      :notes="getCoachNotes('back_neck_pain')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Chronic Condition</strong></td>
                  <td>
                    {{ medicalAssessment.chronicCondition }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="chronic_condition"
                      :notes="getCoachNotes('chronic_condition')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Arthritis</strong></td>
                  <td>
                    {{ medicalAssessment.arthritis }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="arthritis"
                      :notes="getCoachNotes('arthritis')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Soft Tissue Problem</strong></td>
                  <td>
                    {{ medicalAssessment.softTissueProblem }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="soft_tissue_problem"
                      :notes="getCoachNotes('soft_tissue_problem')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Recent Injury</strong></td>
                  <td>
                    {{ medicalAssessment.recentInjury }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="recent_injury"
                      :notes="getCoachNotes('recent_injury')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Recent Injury Notes</strong></td>
                  <td>
                    {{ medicalAssessment.recentInjuryNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="recent_injury_notes"
                      :notes="getCoachNotes('recent_injury_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Musculoskeletal Surgery</strong></td>
                  <td>
                    {{ medicalAssessment.musculoskeletalSurgery }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="musculoskeletal_surgery"
                      :notes="getCoachNotes('musculoskeletal_surgery')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Musculoskeletal Surgery Notes</strong></td>
                  <td>
                    {{ medicalAssessment.musculoskeletalSurgeryNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="musculoskeletal_surgery_notes"
                      :notes="getCoachNotes('musculoskeletal_surgery_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Musculoskeletal Surgery Notes</strong></td>
                  <td>
                    {{ medicalAssessment.musculoskeletalSurgeryNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="musculoskeletal_surgery_notes"
                      :notes="getCoachNotes('musculoskeletal_surgery_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Thyroid Hormonal Problem</strong></td>
                  <td>
                    {{ medicalAssessment.thyroidHormonalProblem }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="thyroid_hormonal_problem"
                      :notes="getCoachNotes('thyroid_hormonal_problem')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Has Had Covid 19</strong></td>
                  <td>
                    {{ medicalAssessment.hasHadCovid19 }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="has_had_covid_19"
                      :notes="getCoachNotes('has_had_covid_19')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Medically Supervised</strong></td>
                  <td>
                    {{ medicalAssessment.medicallySupervised }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="medically_supervised"
                      :notes="getCoachNotes('medically_supervised')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Medically Supervised Notes</strong></td>
                  <td>
                    {{ medicalAssessment.medicallySupervisedNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="medically_supervised_notes"
                      :notes="getCoachNotes('medically_supervised_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Prescribed Medication Notes</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.prescribedMedicationNotes) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="prescribed_medication_notes"
                      :notes="getCoachNotes('prescribed_medication_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Possibly Pregnant</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.possiblyPregnant) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="possibly_pregnant"
                      :notes="getCoachNotes('possibly_pregnant')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Gave Birth Last Six Months</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.gaveBirthLastSixMonths) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="gave_birth_last_six_months"
                      :notes="getCoachNotes('gave_birth_last_six_months')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Reasons To Not Exercise</strong></td>
                  <td>
                    {{ medicalAssessment.reasonsToNotExercise }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="reasons_to_not_exercise"
                      :notes="getCoachNotes('reasons_to_not_exercise')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Reasons To Not Exercise Notes</strong></td>
                  <td>
                    {{ medicalAssessment.reasonsToNotExerciseNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="reasons_to_not_exercise_notes"
                      :notes="getCoachNotes('reasons_to_not_exercise_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item key="Exercise">
            <v-simple-table>
              <tbody>
                <tr>
                  <td><strong>Level of Fitness</strong></td>
                  <td>
                    {{ medicalAssessment.levelOfFitness }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="level_of_fitness"
                      :notes="getCoachNotes('level_of_fitness')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Days Commit</strong></td>
                  <td>
                    {{ medicalAssessment.daysCommit }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="days_commit"
                      :notes="getCoachNotes('days_commit')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Time Commit</strong></td>
                  <td>
                    {{ medicalAssessment.timeCommit }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="time_commit"
                      :notes="getCoachNotes('time_commit')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Walking</strong></td>
                  <td>
                    {{ medicalAssessment.walking }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="walking"
                      :notes="getCoachNotes('walking')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Hiking</strong></td>
                  <td>
                    {{ medicalAssessment.hiking }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="hiking"
                      :notes="getCoachNotes('hiking')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Running</strong></td>
                  <td>
                    {{ medicalAssessment.running }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="running"
                      :notes="getCoachNotes('running')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Swimming</strong></td>
                  <td>
                    {{ medicalAssessment.swimming }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="swimming"
                      :notes="getCoachNotes('swimming')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Strength Training</strong></td>
                  <td>
                    {{ medicalAssessment.strengthTraining }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="strength_training"
                      :notes="getCoachNotes('strength_training')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Intensity Training</strong></td>
                  <td>
                    {{ medicalAssessment.intensityTraining }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="intensity_training"
                      :notes="getCoachNotes('intensity_training')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Working Out at Home</strong></td>
                  <td>
                    {{ medicalAssessment.workingOutAtHome }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="working_out_at_home"
                      :notes="getCoachNotes('working_out_at_home')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Working Out at Gym</strong></td>
                  <td>
                    {{ medicalAssessment.workingOutAtGym }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="working_out_at_gym"
                      :notes="getCoachNotes('working_out_at_gym')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Yoga</strong></td>
                  <td>
                    {{ medicalAssessment.yoga }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="yoga"
                      :notes="getCoachNotes('yoga')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Pilates</strong></td>
                  <td>
                    {{ medicalAssessment.pilates }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="pilates"
                      :notes="getCoachNotes('pilates')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Cycling</strong></td>
                  <td>
                    {{ medicalAssessment.cycling }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="cycling"
                      :notes="getCoachNotes('cycling')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Other Team Sports</strong></td>
                  <td>
                    {{ medicalAssessment.otherTeamSports }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="other_team_sports"
                      :notes="getCoachNotes('other_team_sports')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Other Individual Sports</strong></td>
                  <td>
                    {{ medicalAssessment.otherIndividualSports }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="other_individual_sports"
                      :notes="getCoachNotes('other_individual_sports')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Enjoy Working</strong></td>
                  <td>
                    {{ medicalAssessment.enjoyWorking }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="enjoy_working"
                      :notes="getCoachNotes('enjoy_working')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-tab-item>
          <v-tab-item key="Nutritional Information">
            <v-simple-table>
              <tbody>
                <tr>
                  <td><strong>Food Allergies</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.foodAllergies) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="food_allergies"
                      :notes="getCoachNotes('food_allergies')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Food Allergies Notes</strong></td>
                  <td>
                    {{ medicalAssessment.foodAllergiesNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="food_allergies_notes"
                      :notes="getCoachNotes('food_allergies_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Special Diet</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.specialDiet) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="special_diet"
                      :notes="getCoachNotes('special_diet')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Special Diet Notes</strong></td>
                  <td>
                    {{ medicalAssessment.specialDietNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="special_diet_notes"
                      :notes="getCoachNotes('special_diet_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Nutritional Supplements</strong></td>
                  <td>
                    {{ boolToHuman(medicalAssessment.nutritionalSupplements) }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="nutritional_supplements"
                      :notes="getCoachNotes('nutritional_supplements')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Nutritional Supplements Notes</strong></td>
                  <td>
                    {{ medicalAssessment.nutritionalSupplementsNotes }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="nutritional_supplements_notes"
                      :notes="getCoachNotes('nutritional_supplements_notes')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Nutritional Habit Rating</strong></td>
                  <td>
                    {{ medicalAssessment.nutritionalHabitRating }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="nutritional_habit_rating"
                      :notes="getCoachNotes('nutritional_habit_rating')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Eat Frequently</strong></td>
                  <td>
                    {{ medicalAssessment.eatFrequently }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="eat_frequently"
                      :notes="getCoachNotes('eat_frequently')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>How Many Meals</strong></td>
                  <td>
                    {{ medicalAssessment.howManyMeals }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="how_many_meals"
                      :notes="getCoachNotes('how_many_meals')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Eat Out</strong></td>
                  <td>
                    {{ medicalAssessment.eatOut }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="eat_out"
                      :notes="getCoachNotes('eat_out')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Consume Fruit Vegetables</strong></td>
                  <td>
                    {{ medicalAssessment.consumeFruitVegetables }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="consume_fruit_vegetables"
                      :notes="getCoachNotes('consume_fruit_vegetables')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Consume Starch</strong></td>
                  <td>
                    {{ medicalAssessment.consumeStarch }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="consume_starch"
                      :notes="getCoachNotes('consume_starch')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Consume Protein</strong></td>
                  <td>
                    {{ medicalAssessment.consumeProtein }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="consume_protein"
                      :notes="getCoachNotes('consume_protein')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Consume Fats</strong></td>
                  <td>
                    {{ medicalAssessment.consumeFats }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="consume_fats"
                      :notes="getCoachNotes('consume_fats')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Daily Hydration</strong></td>
                  <td>
                    {{ medicalAssessment.dailyHydration }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="daily_hydration"
                      :notes="getCoachNotes('daily_hydration')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
                <tr>
                  <td><strong>Consume Alcohol</strong></td>
                  <td>
                    {{ medicalAssessment.consumeAlcohol }}
                  </td>
                  <td>
                    <coach-medical-assessment-field-note
                      :medical-assessment-id="parseInt(medicalAssessment.id)"
                      column="consume_alcohol"
                      :notes="getCoachNotes('consume_alcohol')"
                      @update-the-notes-please="refresh()"
                    />
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-tab-item>
        </v-tabs-items>
      </template>
      <template v-if="!loading && !medicalAssessment">
        <v-alert type="warning">Oh no, this user doesnt have a valid medical assessment.</v-alert>
      </template>
    </v-card>
  </v-container>
</template>

<script>
import { CLIENT_MEDICAL_ASSESSMENT_QUERY } from "@/constants/graphql/medical_assessment/medical_assessment";
import CoachMedicalAssessmentFieldNote from "@/components/client/blocks/CoachMedicalAssessmentFieldNote";

export default {
  name: "ClientMedicalAssessment",
  components: {
    CoachMedicalAssessmentFieldNote,
  },
  props: ["userId"],
  data() {
    return {
      loading: true,
      tab: 0,
      medicalAssessment: {},
    };
  },
  methods: {
    boolToHuman(val) {
      return val ? "Yes" : "No";
    },
    getCoachNotes(field_name) {
      return this.medicalAssessment.coachNotes.filter((note) => note.column === field_name);
    },
    refresh() {
      this.$apollo.queries.medicalAssessment.refetch();
    },
  },
  apollo: {
    medicalAssessment: {
      query: CLIENT_MEDICAL_ASSESSMENT_QUERY,
      variables() {
        return {
          userId: this.userId,
        };
      },
      fetchPolicy: "cache-and-network",
      result(response) {
        if (response.data) {
          this.loading = false;
        }
      },
    },
  },
};
</script>

<style scoped>
tr td:first-child {
  width: 35%;
}
</style>
